export const formatDate = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        return "";
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const parseDateStringToLocalDate = (dateString) => {
    if (!dateString || typeof dateString !== "string") {
        return null;
    }

    const [year, month, day] = dateString.split("-").map(Number);

    if (!year || !month || !day) {
        return null;
    }

    const parsedDate = new Date(year, month - 1, day);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};
